import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

function get(locationId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/locations/${locationId}/profiles`, requestOptions).then(handleResponse);
}

export const locationsProfilesService = {
    get,
};
